import React from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import { isEmpty } from 'lodash';
import ValidationMessage from './ValidationMessage';

class DateRangeValidation extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isInvalid: false };
    }

    componentDidMount() {
        this.validate();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.validate();
        }
    }

    componentWillUnmount() {
        // Whenever the component is unmount then it needs to let the parent know.
        if (this.props.onValidated) {
            this.props.onValidated(false, null);
        }
    }

    getDefaultMessage() {
        const defaultMessage = (<ValidationMessage controlName={this.props.controlLabel} message=" is not in specified date range." />);
        const message = this.props.children || defaultMessage;
        return message;
    }

    validate() {
        let minDateViolated = false;
        let maxDateViolated = false;

        if (!validator.isEmpty(this.props.value)) {
            minDateViolated = !isEmpty(this.props.isBefore) && !validator.isBefore(this.props.value, this.props.isBefore);
            maxDateViolated = !isEmpty(this.props.isAfter) && !validator.isAfter(this.props.value, this.props.isAfter);
        }
        const isInvalid = minDateViolated || maxDateViolated;
        const message = this.getDefaultMessage();
        const isCritical = this.props.isCritical;

        this.setState({ isInvalid });
        if (this.props.onValidated) {
            this.props.onValidated(isInvalid, message);
        }
        return { isInvalid, message, isCritical };
    }

    render() {
        if (this.props.displayInSummary || !this.state.isInvalid) {
            return null;
        }
        const message = this.getDefaultMessage();
        return message;
    }
}

DateRangeValidation.defaultProps = {
    children: null,
    displayInSummary: false,
    isCritical: false,
    isBefore: '',
    isAfter: ''
};

DateRangeValidation.propTypes = {
    controlLabel: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
    ]).isRequired,
    displayInSummary: PropTypes.bool,
    isCritical: PropTypes.bool,
    isBefore: PropTypes.string,
    isAfter: PropTypes.string,
    children: PropTypes.element,
    onValidated: PropTypes.func
};

export default DateRangeValidation;
